import { getNativeToken } from '@ui/constants/tokens';

import { useDataChainId } from './datachain';

export const useGasToken = () => {
  const chainId = useDataChainId();

  return getNativeToken(chainId);
};
